export default "__VITE_ASSET__Dye0VUz7__"